/*
 * File: DeliveryDetails.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 28 Dec 2021 2:48:37 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Col, DatePicker, Form, Input, Row, Typography } from 'antd';
import { CreateSalesOrderType } from 'common/enums/CreateSalesOrderType';
import { AttentionInput } from 'components/atoms/deliveryDetailsInputs/AttentionInput';
import { FreightTermsInput } from 'components/atoms/deliveryDetailsInputs/FreightTermsInput';
import { ModeofDeliveryInput } from 'components/atoms/deliveryDetailsInputs/ModeofDeliveryInput';
import { useFormikContext } from 'formik';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { SalesOrderPayloadModel } from 'models/SalesOrderPayloadModel';
import moment from 'moment';
import { useLocation, useParams } from 'react-router-dom';
import { useGetSalesOrderQuery } from 'redux/services/useMamaBearService';

const { Title } = Typography;

const styles: InlineStylesModel = {
  formItem: {
    marginBottom: 10
  },
  formItemCol: {
    marginRight: '16px',
    maxHeight: '42px'
  },
  titleColor: {
    color: '#2F5596'
  },
  datePicker: {
    width: '100%',
    marginBottom: 10
  }
};

export const DeliveryDetails = (): JSX.Element => {
  const { values, handleChange, setValues } = useFormikContext<SalesOrderPayloadModel>();
  const { pathname } = useLocation();
  const isPosted = pathname.includes('/posted');
  const { id: salesOrderId } = useParams();

  const { data: salesOrderData, isLoading: isOrderLoading, isFetching } = useGetSalesOrderQuery({ id: salesOrderId as string }, { skip: !salesOrderId });

  /* ****************** Render ****************** */
  return (
    <Row gutter={[32, 16]} style={{ width: '100%' }}>
      <Col xs={24} sm={24} md={12} lg={12}>
        <Title level={5} style={styles.titleColor}>
          {CreateSalesOrderType.DELIVERY_NAME}
        </Title>
        <Form.Item style={styles.formItem}>
          <Input disabled={isPosted} name="deliveryAddressName" allowClear value={values.deliveryAddressName || ''} onChange={handleChange} />
        </Form.Item>
        {/* <Title level={5} style={styles.titleColor}>
          {CreateSalesOrderType.DESCRIPTION}
        </Title> */}
        {/* <Form.Item style={styles.formItem}>
          <Input disabled={isPosted || !!salesOrderData?.deliveryAddressDescription} name="deliveryAddressDescription" allowClear value={values.deliveryAddressDescription} onChange={handleChange} />
        </Form.Item> */}

        <Title level={5} style={styles.titleColor}>
          {CreateSalesOrderType.DELIVERY_CONTACT}
        </Title>
        <Form.Item style={styles.formItem}>
          <Input disabled={isPosted} name="deliveryContactName" allowClear value={values.deliveryContactName} onChange={handleChange} />
        </Form.Item>

        <Title level={5} style={styles.titleColor}>
          {CreateSalesOrderType.DELIVERY_PHONE}
        </Title>
        <Form.Item style={styles.formItem}>
          <Input disabled={isPosted} name="deliveryContactPhone" value={values.deliveryContactPhone} allowClear onChange={handleChange} />
        </Form.Item>
        <AttentionInput />
      </Col>
      <Col xs={24} sm={24} md={12} lg={12}>
        <Title level={5} style={styles.titleColor}>
          {CreateSalesOrderType.REQUEST_SHIP_DATE}
        </Title>
        <DatePicker
          disabled={isPosted}
          name="requestedShipDate"
          value={values.requestedShipDate ? moment(values.requestedShipDate) : undefined}
          disabledDate={(current: moment.Moment): boolean => {
            return current && current < moment().startOf('day');
          }}
          onChange={(_, dateString): void => {
            setValues((prevState) => ({
              ...prevState,
              requestedShipDate: dateString || '',
              deliveryDate: dateString || ''
            }));
          }}
          style={styles.datePicker}
        />
        <FreightTermsInput />
        <ModeofDeliveryInput />
      </Col>
    </Row>
  );
};
